export default "__VITE_ASSET__24cd17db__"